import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface TakeawayOrderItemPayload {
  dishId: string;
  quantity: number;
}

export interface CreateTakeawayOrderPayload {
  restaurantId: string;
  items: TakeawayOrderItemPayload[];
  customerName: string;
  customerContact: string;
  customerEmail: string;
  // optional: keep these ONLY if backend still expects them
  // amount?: number;
  // quantity?: number;
}

@Injectable({
  providedIn: 'root',
})
export class TakeawayService {
  private baseUrl = `${environment.apiUrl}/api/udaan`;

  constructor(private http: HttpClient) { }

  async createOrder(orderData: CreateTakeawayOrderPayload): Promise<any> {
  try {
    const res = await firstValueFrom(
      this.http.post(`${this.baseUrl}/takeaway-order`, orderData)
    );
    return res;
  } catch (error) {
    console.error('❌ Error creating takeaway order:', error);
    throw error;
  }
}
}
